var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetodologyStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.832 10.1135C29.8388 4.41375 38.8168 1.05762 49.3823 1.05762C62.8755 1.05762 75.1102 5.71809 83.9716 14.5568",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.724 28.0215C95.788 34.3947 97.5049 41.53 97.5049 49.0579C97.5049 59.5963 94.1402 68.5514 88.4258 76.5377",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9331 88.002C68.9263 93.7018 59.9483 97.0579 49.3828 97.0579C22.3964 97.0579 1.25977 75.9754 1.25977 49.0579C1.25977 38.5195 4.62451 29.5644 10.3389 21.5781",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3561 59.6823C25.7919 56.4685 24.9141 52.8632 24.9141 49.0572C24.9141 35.5985 35.8902 24.6504 49.3834 24.6504C56.13 24.6504 62.2474 27.3874 66.678 31.8069",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8146 47.6963C73.8395 48.1468 73.8522 48.6006 73.8522 49.0572C73.8522 62.5159 62.876 73.4639 49.3828 73.4639C45.567 73.4639 41.9525 72.5884 38.7305 71.0282",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1651 8.37988L49.3828 49.0579",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0803 74.4519C36.585 74.4519 40.2367 70.8094 40.2367 66.3163C40.2367 61.8231 36.585 58.1807 32.0803 58.1807C27.5756 58.1807 23.9238 61.8231 23.9238 66.3163C23.9238 70.8094 27.5756 74.4519 32.0803 74.4519Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1721 90.8962C87.6768 90.8962 91.3285 87.2538 91.3285 82.7606C91.3285 78.2674 87.6768 74.625 83.1721 74.625C78.6674 74.625 75.0156 78.2674 75.0156 82.7606C75.0156 87.2538 78.6674 90.8962 83.1721 90.8962Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.594 23.4899C20.0986 23.4899 23.7504 19.8475 23.7504 15.3543C23.7504 10.8612 20.0986 7.21875 15.594 7.21875C11.0893 7.21875 7.4375 10.8612 7.4375 15.3543C7.4375 19.8475 11.0893 23.4899 15.594 23.4899Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetodologyStep1);
export default __webpack_public_path__ + "static/media/metodology-step1.1354373ad8ac73d0e4728bd6ab67053e.svg";
export { ForwardRef as ReactComponent };